<template>
  <form
    class="flex min-h-full w-full max-w-sm flex-grow flex-col space-y-6"
    @submit="onSubmit"
  >
    <FormInputPassword
      autocomplete="new-password"
      label="New Password"
      name="password"
    />
    <FormInputPassword
      autocomplete="new-password"
      label="Confirm Password"
      name="confirmPassword"
    />

    <div class="flex justify-end">
      <FormSubmitButton class="w-full">
        Update Password
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/utilityTypes"
import { toTypedSchema } from "@vee-validate/zod"

import {
  useForm,
  type SubmissionContext,
} from "vee-validate"
import z from "zod"

const newPasswordFormSchema = z
  .object({
    password: z
      .string()
      .min(8, "Password must be at least 8 characters"),
    confirmPassword: z.string(),
  })
  .superRefine(({ password, confirmPassword }, context) => {
    if (password !== confirmPassword) {
      context.addIssue({
        path: ["confirmPassword"],
        code: "custom",
        message: "Passwords do not match",
      })
    }
  })

export type UserPasswordFormInput = TypedSchemaInput<
  typeof newPasswordFormSchema
>

export type UserPasswordFormOutput = TypedSchemaOutput<
  typeof newPasswordFormSchema
>

const emit = defineEmits<{
  (
    event: "submit",
    params: UserPasswordFormOutput,
    context: SubmissionContext<UserPasswordFormInput>
  ): void
}>()

const { handleSubmit } = useForm({
  validationSchema: toTypedSchema(newPasswordFormSchema),
})

const onSubmit = handleSubmit(async (values, context) => {
  emit("submit", values, context)
})
</script>
